(function ($) {
    $(function () {                
        var $html = $( 'html' );
        var cookieName = "ax-recommended";
        var recommendedIds = ($.cookie(cookieName) || '').split('&');
        var currentLanguage = $html.attr('lang');
        var currentSite = $html.attr('data-site');
        
        $('.hlStandards').click(function (e) {
            e.preventDefault();

            var sActID = $(this).closest("div").siblings('[id*="hdnCheckActID"]').val();
            var legacyID = $(this).closest("div").siblings('[id*="hdnCheckLegacy"]').val();
            var ID = sActID;

            if( legacyID ) {
                ID = legacyID;
            }

            Dialogs.Init('Standards', function (dialogData) {
                dialogData.Open({ optional: true, aID: ID });
            });
        });

        $('.hlTextbook').click(function (e) {
            e.preventDefault();

            var sActID = $(this).closest("div").siblings('[id*="hdnCheckActID"]').val();
            var legacyID = $(this).closest("div").siblings('[id*="hdnCheckLegacy"]').val();
            var ID = sActID;

            if( legacyID ) {
                ID = legacyID;
            }

            Dialogs.Init('AlignTextbooks', function (dialogData) {
                dialogData.Open({ optional: true, aID: ID });
            });
        });

        $('#activity-search-results tbody tr td.preview a')
        .click(function (e) {
            var activityHero = $(this).closest(".preview").find("input.hdnActHero").val();
            var activitySummary = $(this).closest(".preview").find("input.hdnActSummary").val();
            if ($(this).hasClass('image')) {
                e.preventDefault();
                Dialogs.Init('PreviewImage', function (dialogData) {
                    dialogData.Open({ optional: true, aHero: activityHero, aSummary: activitySummary });
                });
            } else {
                Dialog.PreviewVideo.Open({ src: $(this).attr('rel') });
            }
        });

        // Code for Recommendation/Likes
        $('.recommend_off').click(function (e) {
            var activityId = $(this).children().attr("href");
            var $t = $(this);
            e.preventDefault();
            var value = activityId + '=1';

            var recommended = false;
            $.each(recommendedIds, function () {
                if (this == value) recommended = true;
            });

            if (!recommended) {
                $.ajax({
                    type: "POST",
                    url: Services.GetUrl( "/Services/Downloads/ActivitiesRecommend.ashx" ),
                    data: { lang: currentLanguage, site: currentSite, activitySId: activityId },
                    success: function (data) {
                        if (data.toString() == "true") {
                            var $span = $t.next().find("span");
                            var c = parseInt($span.text(), 10);
                            if (!isNaN(c)) $span.eq(0).text(c + 1);
                            else $span.eq(0).text(c = 1);
                        }
                        else {
                            Dialogs.Init('Notify', function (dialogData) {
                                dialogData.Open({ optional: true, title: 'Activities / Error', text: data.toString(), showCancel: false });
                            });
                        }
                        var pathname = window.location.host;
                        recommendedIds.push(value);
                        $.cookie(cookieName, recommendedIds.join('&'), { domain: window.location.host, path: '/',  secure: true });
                    }
                });

                $(this).closest("li").removeClass('recommend_off').addClass('recommend_on');
            }
        })
        .each(function () {
            var activityId = $(this).children().attr("href");
            var value = activityId + '=1';
            var recommended = false;
            $.each(recommendedIds, function () {
                if (this == value) recommended = true;
            });
            if (recommended) $(this).closest("li").removeClass('recommend_off').addClass('recommend_on');
        });


        // Code for Save Activity
        $('.save_off, .save_on')
		.click(function (e) {
		    e.preventDefault();
		    var li = $(this);
		    var activityId = li.closest("td.collection-icon").prev("td.recommend").find(".actGUID").attr("href");
		    
		    if ($html.hasClass('visitor-signed-in')) showDialog();
		    else Dialogs.SignIn.Open({ optional: false, callback: showDialog });

		    function showDialog() {
		        if (li.hasClass('save_on')) {
		            Dialogs.Init('Notify', function (dialogData) {
		                dialogData.Open({ optional: false, title: 'Activities/Remove Activity', text: 'Activities/Remove Activity Mssg', showCancel: true, callback: function () {
		                    $.ajax({
		                        type: "POST",
		                        url: Services.GetUrl( "/Services/Downloads/TrackMyActivity.ashx" ),
		                        data: { lang: currentLanguage, site: currentSite, activitySId: activityId, mode: 'Unsave' },
		                        success: function (data) {
		                            if (data.toString() == "true") {
		                                li.removeClass('save_on').addClass('save_off');
		                                li.attr("title", "Save Activity");
		                                if ($html.hasClass('visitor-signed-out')) {
		                                    location.reload();
		                                }
		                            }
		                            else {
		                                Dialogs.Init('Notify', function (dialogData) {
		                                    dialogData.Open({ optional: true, title: 'Activities/Remove Activity', text: data.toString(), showCancel: false });
		                                });
		                            }
		                        }
		                    });
		                }
		                });
		            });
		        }
		        else {
		            Dialogs.Init('Notify', function (dialogData) {
		                dialogData.Open({ optional: false, title: 'Activities/Save Activities', text: 'Activities/Activity Saved', showCancel: false, callback: function () {
		                    $.ajax({
		                        type: "POST",
		                        url: Services.GetUrl( "/Services/Downloads/TrackMyActivity.ashx" ),
		                        data: { lang: currentLanguage, site: currentSite, activitySId: activityId, mode: 'Save' },
		                        success: function (data) {
		                            if (data.toString() == "true") {
		                                li.removeClass('save_off').addClass('save_on');
		                                li.attr("title","Remove Activity");
		                                if ($html.hasClass('visitor-signed-out')) {
		                                    location.reload();
		                                }
		                            }
		                            else {
		                                Dialogs.Init('Notify', function (dialogData) {
		                                    dialogData.Open({ optional: false, title: 'Activities/Save Activities', text: data.toString(), showCancel: false });
		                                });
		                            }
		                        }
		                    });
		                }
		                });
		            });
		        }
		    }
		});

        // Code for Download
        $('.download')
		.click(function (e) {
		    var $t = $(this);
		    var activityId = $t.closest("td.downloads").next("td.recommend").find(".actGUID").attr("href");

		    $.ajax({
		        type: "POST",
		        url: Services.GetUrl( "/Services/Activities/TrackDownload.ashx" ),
		        data: { lang: currentLanguage, site: currentSite, activityid: activityId },
		        success: function (data) {
		            //alert(data.toString());
		            if (data.toString() != null) {
		                $t.find("a").attr("href", data.toString());
		                //alert("success");
		                window.location.replace(data.toString());
		            }
		            else {
		                //alert("failed");
		            }
		        }
		    });
		});
    });
} (jQuery));